import styled, { AnyStyledComponent } from 'styled-components';
import { Input } from 'antd';

export const GenericInputSearchStyle = styled(
  Input.Search as unknown as AnyStyledComponent,
)``;
